import React from 'react'

const Pointer = () => {
    return (
        <div className='container'>
            <h1>Pointer</h1>
            
                <h3>What is pointer?</h3>
             <p>   A pointer is a variable whose value is the address of another variable, i.e., direct address of the memory location. Like any variable or constant, you must declare a pointer before using it to store any variable address. The general form of a pointer variable declaration is − <br /> <br />
                type *var-name; <br /> <br />
                Here, type is the pointer's base type; it must be a valid C data type and var-name is the name of the pointer variable. The asterisk * used to declare a pointer is the same asterisk used for multiplication. However, in this statement the asterisk is being used to designate a variable as a pointer. Take a look at some of the valid pointer declarations − <br />
                int    *ip;    /* pointer to an integer */ <br />
double *dp;    /* pointer to a double */  <br />
float  *fp;    /* pointer to a float */ <br />
char   *ch     /* pointer to a character */ <br /></p>
           
            <h3>NULL Pointers</h3>
           
            It is always a good practice to assign a NULL value to a pointer variable in case you do not have an exact address to be assigned. This is done at the time of variable declaration. A pointer that is assigned NULL is called a null pointer.
<br />
The NULL pointer is a constant with a value of zero defined in several standard libraries. Consider the following program <br />

           <div className='containers'>
         <code className='library'>  #include </code>&lt;stdio.h&gt;<br/>
<br/>
<code className='keywords'>int</code> main () &#123;<br/>
<br/>
<code className='keywords'>  int </code> *ptr = NULL;<br/>
<br/>
<code className='library'> printf </code>("The value of ptr is : %x\n", ptr  );<br/>
 <br/>
 <code className='library'>  return </code>0;<br/>
&#125; <br/>
           </div>
           <h3>How to Use Pointers?</h3>
           There are a few important operations, which we will do with the help of pointers very frequently. (a) We define a pointer variable, (b) assign the address of a variable to a pointer and (c) finally access the value at the address available in the pointer variable. This is done by using unary operator * that returns the value of the variable located at the address specified by its operand. The following example makes use of these operations − <br />
           <div className='containers'>
         <code className='library'>  #include </code>&lt;stdio.h&gt;<br/>
<br/>
<code className='keywords'></code>int main () &#123;<br/>
<br/>
<code className='keywords'> int</code>  var = 20; <br/>
   <br/> <code className='comment'> /* actual variable declaration */</code>
   <code className='keywords'> int </code>  *ip; <br/>     
   <br/> <code className='comment'>/* pointer variable declaration */</code> 
<br/>
   ip = &var; <br/>
   <br/><code className='comment'> /* store address of var in pointer variable*/</code>
<br/>
<code className='library'>  printf</code>("Address of var variable: %x\n", &var  );<br/>
<br/>
<code className='comment'>/* address stored in pointer variable */</code><br/>
<code className='library'>printf</code>("Address stored in ip variable: %x\n", ip );<br/>
<br/>
<code className='comment'>/* access the value using the pointer */</code><br/>
<code className='library'>  printf</code> ("Value of *ip variable: %d\n", *ip );<br/>
<br/>
<code className='library'>  return </code>0;<br/>
&#125; <br/>
           </div>
           <h1>Pointer v/s Array</h1>
            <div className='container'>
            Most of the time, pointer and array accesses can be treated as acting the same, the major exceptions being:
<br /> <br />
1) the sizeof operator <br />
o sizeof(array) returns the amount of memory used by all elements in array <br />
o sizeof(pointer) only returns the amount of memory used by the pointer variable itself <br />
<br />
2) the & operator  <br />
o &array is an alias for &array[0] and returns the address of the first element in array <br />
o &pointer returns the address of pointer <br />
<br />
3) a string literal initialization of a character array <br />
o char array[] = “abc” sets the first four elements in array to ‘a’, ‘b’, ‘c’, and ‘\0’ <br />
o char *pointer = “abc” sets pointer to the address of the “abc” string (which may be stored in read-only memory and thus unchangeable) <br />
<br />
4) Pointer variable can be assigned a value whereas array variable cannot be. <br />
            </div>
        </div>
    )
}

export default Pointer
